import { Component } from '@angular/core';
import { ChatService, ChatDialogState } from '../chat.service';
import { ResponsiveDesignService, ScreenType } from 'src/app/common/services/responsive-design/responsive-design.service';
import { UIUtilityService } from '../../../../system/utility/ui-utility.service';
import { ChatStatus } from 'src/app/business/help-desk/help-desk-ticket';
import { ChatContextService } from '../chat-context.service';

@Component({
    selector: 'app-chat-dialog',
    templateUrl: './chat-dialog.component.html',
    styleUrl: './chat-dialog.component.less',
    standalone: false
})
export class ChatDialogComponent {

  protected ChatDialogState: any = ChatDialogState;
  protected ChatStatus: any = ChatStatus;
  protected UIUtilityService: any = UIUtilityService;

  constructor(
    public srvChat: ChatService,
    protected srvChatContext: ChatContextService,
    private srvResponsive: ResponsiveDesignService) {
  }

  // Return the Minimized Width
  protected getMinimizedWidth(): any {
    switch (this.srvResponsive.screenType.value) {
      case ScreenType.TypeXS:
      case ScreenType.TypeS:
        return { 'width': '250px' }
      case ScreenType.TypeM:
      case ScreenType.TypeL:
      case ScreenType.TypeXL:
        return { 'width': '300px' }
    }
  }

  protected changeState(newState: ChatDialogState) {
    this.srvChat.changeState(newState);
  }

}
